import { AuthContext, Spinner } from '@enter/core';
import React, { useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export const AcceptInvitation: React.FC = () => {
    const authContext = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const invitation_code = query.get('invitation_code');

        if (invitation_code) {
            authContext.logoutAndRedirect(new Map([
                ['redirect_uri', window.location.origin],
                ['invitation_code', invitation_code],
            ]));
        } else {
            navigate('/', { replace: true });
        }
    }, [authContext, navigate, location.search]);

    return <Spinner />;
};
